// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_SOLD_TO_LIST = 'GET_SOLD_TO_LIST';
export const GET_SOLD_TO_LIST_SUCCESS = 'GET_SOLD_TO_LIST_SUCCESS';

export const GET_SHIP_TO_LIST = 'GET_SHIP_TO_LIST';
export const GET_SHIP_TO_LIST_SUCCESS = 'GET_SHIP_TO_LIST_SUCCESS';

export const POST_SOLD_TO_SHIP_TO = 'POST_SOLD_TO_SHIP_TO';
export const POST_SOLD_TO_SHIP_TO_SUCCESS = 'POST_SOLD_TO_SHIP_TO_SUCCESS';

export const CLEAR_SOLD_TO_SHIP_TO_MESSAGE = 'CLEAR_SOLD_TO_SHIP_TO_MESSAGE';

export const GET_ONSITE_SOLD_TO_SHIP_TO = 'GET_ONSITE_SOLD_TO_SHIP_TO';
export const GET_ONSITE_SOLD_TO_SHIP_TO_SUCCESS = 'GET_ONSITE_SOLD_TO_SHIP_TO_SUCCESS';

export const {
    getSoldToList,
    getSoldToListSuccess,

    getShipToList,
    getShipToListSuccess,

    postSoldToShipTo,
    postSoldToShipToSuccess,

    clearSoldToShipToMessage,

    getOnsiteSoldToShipTo,
    getOnsiteSoldToShipToSuccess,
} = createActions(
    GET_SOLD_TO_LIST,
    GET_SOLD_TO_LIST_SUCCESS,

    GET_SHIP_TO_LIST,
    GET_SHIP_TO_LIST_SUCCESS,

    POST_SOLD_TO_SHIP_TO,
    POST_SOLD_TO_SHIP_TO_SUCCESS,

    CLEAR_SOLD_TO_SHIP_TO_MESSAGE,

    GET_ONSITE_SOLD_TO_SHIP_TO,
    GET_ONSITE_SOLD_TO_SHIP_TO_SUCCESS
);
